import { AdsJSON } from './AdsJSON'
import { AdsPanel } from './AdsPanel'
import { CurlCommand } from './CurlCommand'

type AsideAdsProps = {
  ads: ResponseAds | undefined
  curlCommand: string | undefined
}

const AsideAds = ({ ads, curlCommand }: AsideAdsProps) => (
  <aside className="col-6">
    <AdsPanel data={ads} />

    <CurlCommand data={curlCommand} />

    <AdsJSON ads={ads} />
  </aside>
)

export default AsideAds
